<template>
    <div id="idEditarMultipleClienteExtraCostoModal">
         <Button
            :size="15"
            color="#FD9137"
            colorText="#ffffff"
            tooltip="Editar Múltiple Clientes Extra Costos"
            icon="far fa-edit"
            round
            :width="30"
            class="mr-2"
            traslate
            @click.native="actionSetShowModalEditMultipleClienteExtraCostoModal(true)"
            :inactive="ids.length < 1"
        />

        <ui-modal 
            ref="modal" 
            title="Editar Múltiple Cliente Extra Costo"
            transition="scale-up"
            size="large"
            @close="actionSetShowModalEditMultipleClienteExtraCostoModal(false)"
         >
             <client-extra-cost-form 
                :ids = "idsData"
                :closeModal = "cerrarModal"
             />
         </ui-modal> 
 
    </div>
 
 </template>
 
 <script>

    import UiModal from "keen-ui/src/UiModal";
    import { mapState, mapActions } from "vuex";
    import ClientExtraCostForm from '../clientesExtraCostos/ClientExtraCostForm.vue';
    import Button from "../../../common/Button";
 
     export default {
 
         props: {
            ids  : { type: Array, default: () => [] },
         },
         data(){
             return {
                id_client : {},
                vigency: "",
                keys : { label: 'name', value: 'id' },
                id_container_type : {},
                id_extra_costos_tipo : {} ,
                id_currency : {},
                id_type_service_integral : {},

                data: [],
                checks: [],
                
                btnAction: false,

                comments: "",
                idsData: []
             }
         },
 
         components: {
            UiModal,
            ClientExtraCostForm,
            Button
         },
 
         computed: {
             ...mapState("serviciosLogisticos", [
                 "showModalEditMultipleClienteExtraCostoModal",
                 "customersList",
                 "listCarriers",
                 "servicesTypeList",
                 "clientsList",
                 "listCurrencies",
                 "extraCostTypes",
                 "unityPayments",
                 "containerTypes",
              ])
         },
         methods : {
 
             ...mapActions([ "ActionSetZindexTablaModal"]),
 
             ...mapActions("serviciosLogisticos",[
                 "actionSetShowModalAgregarClienteExtraCostoModal",
                 "actionSetShowModalEditMultipleClienteExtraCostoModal"
             ]),
 
 
             openModal(ref) {
                 this.ActionSetZindexTablaModal(true);
 
                 this.$refs[ref].open();
             },
             
             closeModal(ref) {
                 this.$refs[ref].close();
                 this.ActionSetZindexTablaModal(false);
             },
             cerrarModal(){
                 this.closeModal('modal');
             },
             valid(){
 
                 if( ! this.id_client.id ){
                     this.$vToastify.warning("Campo Cliente Obligatorio", "Alerta");
                     return false ;
                 }
                 return true ;
             },
             
           
         },
         watch: {
            showModalEditMultipleClienteExtraCostoModal: function( _new ){

                this.idsData = _new ? this.ids : [];

                _new ? this.openModal("modal") : this.cerrarModal() ;
             }
         }
 
     }
 
 </script>
 
 <style>
 
 #idEditarMultipleClienteExtraCostoModal .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
     width: 75% !important;
 }
 </style>